module.exports = __webpack_public_path__ + "static/media/icn-recevez.9d7cf025.svg";